<template>
    <div class="cs3-trial-box" v-if="isShown">
    <div class="cs3-trial-serviceFeaturesHead" @click="toggleServiceFeatureInner">
        <div class="cs3-trial-serviceFeaturesTitle">{{dictionaryFile.serviceFeaturesTitle}}</div>
        <div class="cs3-trial-serviceFeaturesCircle">
          <div class="cs3-trial-serviceFeaturesArrow" v-bind:class="serviceFeaturesOpened ? 'cs3-trial-serviceFeaturesArrow--down': '' " >
          </div>
        </div>
      </div>
      <div class="cs3-trial-serviceFeaturesInner" v-bind:class="serviceFeaturesOpened ? 'cs3-trial-serviceFeaturesInner--opened': '' " v-html="dictionaryFile.serviceFeatures">
        
      </div>
    </div>
</template>

<script>
export default {
    name:"ServiceDetail",
    props: {
        isShown: {
            type: Boolean,
            required: true
        },
        dictionaryFile: {
            type: Object,
            required: true
        }
    },
    data: function(){
        return {
            serviceFeaturesOpened: false
        }
    },
    methods: {
        toggleServiceFeatureInner: function(){
            this.serviceFeaturesOpened = !this.serviceFeaturesOpened;
        }
    }
}
</script>
<style scoped>

.cs3-trial-serviceFeaturesHead {
    font-weight: 700;
    font-size: 16px;
    color: #7762EF;
    cursor: pointer;
    display: grid;
    grid-template-columns: auto 60px;
    margin-top: 20px;
    padding: 10px 0;
  }
  
  .cs3-trial-serviceFeaturesTitle {
    margin-right: -25px;
  }
  
  .cs3-trial-serviceFeaturesInner {
    color: #7A7A7A;
    font-size: 14px;
    font-weight: 400;
    height: 0;
    overflow: hidden;
    transition: height 2s;
  }
  
  .cs3-trial-serviceFeaturesInner--opened {
    height: 200px;
    transition: height 2s;
  }
  
  .cs3-trial-serviceFeaturesCircle {
    width: 26px;
    height: 26px;
    background: #7762EF;
    border-radius: 100%;
  }
  
  .cs3-trial-serviceFeaturesArrow {
    border: solid white;
    border-width: 0 2px 2px 0;
    display: inline-block;
    padding: 4px;
    transform: rotate(-45deg);
    -webkit-transform: rotate(-45deg);
    margin-left: -3px;
    transition: all 1s;
  }
  
  .cs3-trial-serviceFeaturesArrow--down {
    transform: rotate(45deg);
    -webkit-transform: rotate(45deg);
    margin-left: 0;
    margin-bottom: 2px;
    transition: all 1s;
  }
</style>